const CUSTOMER_BET_HISTORY_FEATURE_KEY = "customerBetHistory";
const USER_CONFIG_FEATURE_KEY = "userConfiguration";
const CUSTOMER_FEATURE_KEY = "customer";
const CUSTOMER_TOKEN_FEATURE_KEY = "customerToken";
const CUSTOMER_PREFERENCES_FEATURE_KEY = "customerPreferences";
const BASIC_MODAL_FEATURE_KEY = "basicModal";
const ONDATO_VERIFICATION_FEATURE_KEY = "onDatoVerification";
const GAMIXTER_FEATURE_KEY = "GAMIXTER_FEATURE_KEY";
const TERMS_AND_POLICY_FEATURE_KEY = "termsAndConditions";
const CASHOUT_FEATURE_KEY = "cashout";
const SNACKBAR_NOTIFICATION_FEATURE_KEY = "snackbarNotification";
const CUSTOMER_NO_AUTH_FEATURE_KEY = "customerNoAuth";
const IFINANCE_FEATURE_KEY = "IFINANCE_FEATURE_KEY";
const SERVER_VALIDATION_FEATURE_KEY = "serverValidation";
export {
  BASIC_MODAL_FEATURE_KEY,
  CASHOUT_FEATURE_KEY,
  CUSTOMER_BET_HISTORY_FEATURE_KEY,
  CUSTOMER_FEATURE_KEY,
  CUSTOMER_NO_AUTH_FEATURE_KEY,
  CUSTOMER_PREFERENCES_FEATURE_KEY,
  CUSTOMER_TOKEN_FEATURE_KEY,
  GAMIXTER_FEATURE_KEY,
  IFINANCE_FEATURE_KEY,
  ONDATO_VERIFICATION_FEATURE_KEY,
  SERVER_VALIDATION_FEATURE_KEY,
  SNACKBAR_NOTIFICATION_FEATURE_KEY,
  TERMS_AND_POLICY_FEATURE_KEY,
  USER_CONFIG_FEATURE_KEY
};
